import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "checkboxAll"];
  static values = { baseUrl: String };

  connect() {
    this.changeSelectAllCheckbox();
  }

  // checks if all checkboxes are selected, and turns checkbox on/off accordingly
  changeSelectAllCheckbox() {
    const allCheckboxesSelected = this.checkboxTargets.every(
      (target) => target.checked
    );
    allCheckboxesSelected
      ? (this.checkboxAllTarget.checked = true)
      : (this.checkboxAllTarget.checked = false);
  }

  toggleAll(event) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = event.target.checked;
    });
  }

  checkboxChanged() {
    this.changeSelectAllCheckbox();
  }

  downloadSelectedForms() {
    const checkedForms = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked
    );

    if (checkedForms.length === 0) {
      const message =
        this.element.dataset.downloadCheckedFormsNoSelectionMessage;
      alert(message);
      return;
    }

    checkedForms.forEach((checkbox) => {
      const formId = checkbox.dataset.formId;

      if (!formId) {
        return;
      }

      // Use the base URL from the data attribute
      const downloadUrl = `${this.baseUrlValue}?form_id=${encodeURIComponent(
        formId
      )}`;

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
}
